import { State, Selector, Store, Action, StateContext } from '@ngxs/store';
import { AdminTourModel, AuditGoogleApiCommand, EscalationHistoryModel, GetMyTourHistoryQuery, LoggedIssueModel, NotesClient, NotesModel, PagedListingResponseOfAdminTourModel, PagedListingResponseOfTourListHistoryModel, TourClient, TourHistoryModel, TourLockedModel, TourModel, TourVehicleRouteModel } from '@core/services/api.service';
import { Injectable } from '@angular/core';
import { SignalRService } from '@core/services/signalr.service';
import {
    AddNoteAction, AddNoteFailAction, AddNoteSuccessAction, ApplyFiltersToAdminToursAction, ApplyFiltersToToursAction,
    AssignUserAction, AssignUserFailAction, AssignUserSuccessAction, AssignVehicleAction,
    AssignVehicleFailAction, AssignVehicleSuccessAction, AuditGoogleApiAction, CalculateDistanceAction,
    CalculateDistanceFailAction, CalculateDistanceSuccessAction, CancelTourAction,
    CancelTourFailAction, CancelTourSuccessAction, CreateTourHistoryByTourIdAction, CreateTourHistoryByTourIdSuccessAction, CreateTourHistoryByTourIddFailAction, DisableHistoryItemIdAction, DisableHistoryItemIdFailAction, DisableHistoryItemIdSuccessAction, GetNotesAction, GetRouteByTourIdAction,
    GetRouteByTourIdFailAction, GetRouteByTourIdSuccessAction, GetTourByIdAction,
    GetTourByIdFailAction, GetTourByIdSuccessAction, LoadAdminTourListAction, LoadAdminTourListFailAction, LoadAdminTourListSuccessAction, LoadLoggedIssuesAction, LoadLoggedIssuesFailAction, LoadLoggedIssuesSuccessAction, LoadTourHistoryListAction,
    LoadTourHistoryListFailAction, LoadTourHistoryListSuccessAction, LoadTourListAction,
    LoadTourListFailAction, LoadTourListSuccessAction, LoadTourUpdateHistoryAction,
    LoadTourUpdateHistoryFailAction, LoadTourUpdateHistorySuccessAction, LogAnIssueAction, LogAnIssueFailAction, LogAnIssueSuccessAction, MakeTourCriticalAction,
    MakeTourCriticalFailAction, MakeTourCriticalSuccessAction, MakeTourHeldAtCustomsAction,
    MakeTourHeldAtCustomsFailAction, MakeTourHeldAtCustomsSuccessAction, MarkTourCompletedAction,
    MarkTourCompletedFailAction, MarkTourCompletedSuccessAction, RegisterSignalRHandlersForTourAction,
    RemoveTourLockByIdAction,
    RemoveTourLockByIdFailAction,
    RemoveTourLockByIdSuccessAction,
    RemoveNotificationSh, AddNotificationSh, RegisterSignalRHandlersForChatShAction,
    SaveRouteAction, SaveRouteFailAction, SaveRouteSuccessAction,
    SetCategoryFilterAction, SetDepartmentsFilterAction,
    SetTypesFilterAction, TourLockHistoryByIdAction,
    TourLockHistoryByIdFailAction, TourLockHistoryByIdSuccessAction,
    UnCancelTourAction,
    UnCancelTourFailAction,
    UnCancelTourSuccessAction,
    UpdateETAAction, UpdateETAFailAction, UpdateETASuccessAction,
    UpdateHistoryItemByIdAction,
    UpdateHistoryItemByIdFailAction,
    UpdateHistoryItemByIdSuccessAction,
    UpdateTrackingFreqAction,
    UpdateTrackingFreqFailAction,
    UpdateTrackingFreqSuccessAction,
    UpdateTrackingUrlAction, UpdateTrackingUrlFailAction,
    UpdateTrackingUrlSuccessAction,
    SetShipmentModeAction,
    CloseIssueAction,
    CloseIssueSuccessAction,
    CloseIssueFailAction,
    SetOwningUserFilterAction,
    ClearSelectedTourAction,
    AddTrailerRegByTourIdAction, AddTrailerRegByTourIdSuccessAction, AddTrailerRegByTourIdFailAction,
} from './managed-tour.actions';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { LoadCustomsDashboardsV1Action, LoadDashboardsAction } from '@ngxs-store/dashboards-store/dashboards.actions';
import { TourLocked } from '@core/models/tour-locked/tour-locked.model';
import { LoadActiveTourListAction, LoadMyTourHistoryListAction, LoadMyTourListAction } from '@ngxs-store/my-tours-store/my-tours.action';
import { EscalationChatDialogComponent } from '@shared/components/escalation-chat-dialog/escalation-chat-dialog.component';
import { NotificationSnackbarComponent } from '@shared/components/notification-snack-bar/notification-snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { map } from 'rxjs/operators';
import { LoadControlTowerDashboardsAction, LoadEscalatedToursAction } from '@ngxs-store/control-tower-store/control-tower.actions';
import { LoadCustomsListAction, LoadListOfOpenChatsAction, SetHasNewMessagesForCustomsListAction, SetHasNewMessagesForManagedToursAction } from '@ngxs-store/customs-store/customs.actions';
import { CustomsState } from '@ngxs-store/customs-store/customs.state';
import { OpenSnackbarAction } from '@ngxs-store/ui-store/ui.actions';
import { SnackbarType } from '@core/models';
import { CustomsHistoryModel } from '@core/services/api.service';

export class ManagedTourStateModel {
    public isLoading: boolean;
    public tourList: TourModel[];
    public adminTours: AdminTourModel[];
    public adminTourList: PagedListingResponseOfAdminTourModel;
    public filteredTourList: TourModel[];
    public filteredAdminTourList: AdminTourModel[];
    public selectedCategory: string;
    public selectedDepartments: number[];
    public selectedTypes: number[];
    public selectedOwningUsers: string[];
    public signalRHandlersRegistered: boolean;
    public tourHistory: TourHistoryModel[];
    public tourHistoryList: PagedListingResponseOfTourListHistoryModel;
    public tourUpdateHistory: TourHistoryModel[];
    public selectedTour: TourModel;
    public notes: NotesModel[];
    public route: TourVehicleRouteModel;
    public locked: any;
    public name: any;
    public loggedIssues: LoggedIssueModel[];
    public selectedModes: string[];
}

@State<ManagedTourStateModel>({
    name: 'ManagedTours',
    defaults: {
        isLoading: true,
        tourList: [],
        adminTours: [],
        adminTourList: null,
        filteredTourList: [],
        filteredAdminTourList: [],
        selectedCategory: '',
        selectedDepartments: [],
        selectedTypes: [],
        selectedOwningUsers: [],
        signalRHandlersRegistered: false,
        tourHistory: [],
        tourHistoryList: null,
        tourUpdateHistory: [],
        selectedTour: null,
        notes: [],
        route: null,
        locked: null,
        name: null,
        loggedIssues: [],
        selectedModes: []
    }
})
@Injectable()
export class ManagedToursState {
    constructor(private tourService: TourClient, private noteService: NotesClient, private store: Store,
        public signalRService: SignalRService,  private snackBar: MatSnackBar,
        public dialog: MatDialog) { }

    @Selector()
    static getIsLoading(state: ManagedTourStateModel) {
        return state.isLoading;
    }
    @Selector()
    static getAdminToursList(state: ManagedTourStateModel) {
        return state.adminTourList;
    }
    @Selector()
    static getAdminTours(state: ManagedTourStateModel) {
        return state.adminTours;
    }
    @Selector()
    static getFilteredTours(state: ManagedTourStateModel) {
        return state.filteredTourList;
    }
    @Selector()
    static getAdminTourHistory(state: ManagedTourStateModel) {
        return state.tourHistory;
    }

    @Selector()
    static getTourHistory(state: ManagedTourStateModel) {
        return state.tourHistory;
    }

    @Selector()
    static getTourUpdateHistory(state: ManagedTourStateModel) {
        return state.tourUpdateHistory;
    }


    @Selector()
    static getTourHistoryList(state: ManagedTourStateModel) {
        return state.tourHistoryList;
    }

    @Selector()
    static getSelectedDepartments(state: ManagedTourStateModel) {
        return state.selectedDepartments;
    }
    @Selector()
    static getSelectedtypes(state: ManagedTourStateModel) {
        return state.selectedTypes;
    }

    @Selector()
    static getSelectedOwningUsers(state: ManagedTourStateModel) {
        return state.selectedOwningUsers;
    }

    @Selector()
    static getRouteByTourId(state: ManagedTourStateModel) {
        return state.route;
    }

    @Selector()
    static getLoggedIssues(state: ManagedTourStateModel) {
        return state.loggedIssues;
    }

    @Selector()
    static getSelectedModes(state: ManagedTourStateModel) {
        return state.selectedModes;
    }

    @Action(GetTourByIdAction)
    GetTourByIdAction({ patchState, dispatch }: StateContext<ManagedTourStateModel>, action: GetTourByIdAction) {
        patchState({ isLoading: true });
        return this.tourService.getTourById(action.tourId, action.transportOrderNumber).pipe(
            tap((tour) => dispatch(new GetTourByIdSuccessAction(tour))),
            catchError(error => {
                dispatch(new GetTourByIdFailAction());
                throw error;
            })
        );
    }

    @Action(GetTourByIdFailAction)
    GetTourByIdFailAction(ctx: StateContext<ManagedTourStateModel>, action: GetTourByIdFailAction) {
        ctx.patchState({
            isLoading: false,
            selectedTour: null
        });
    }

    @Action(AuditGoogleApiAction)
    AuditGoogleApiAction(ctx: StateContext<ManagedTourStateModel>, action: AuditGoogleApiAction) {
        return this.tourService.auditGoogleApi(new AuditGoogleApiCommand({ updateType: action.updateType })).pipe(
            tap((tourUpdateHistory) => {
                console.log('Google API audit successful');
                // You can log additional information here if needed
            }),
            catchError((err) => {
                console.error('Error occurred during Google API audit:', err);
                return err; // Re-throw the error to propagate it down the observable chain
            })
        );
    }

    @Action(LoadTourUpdateHistoryAction)
    LoadTourHistoryAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: LoadTourUpdateHistoryAction) {
        patchState({ isLoading: true });
        return this.tourService.getTourHistoryByTourId(action.entityId).pipe(
            tap((tourUpdateHistory) => dispatch(new LoadTourUpdateHistorySuccessAction({ tourUpdateHistory }))),
            catchError((err) => dispatch(new LoadTourUpdateHistoryFailAction()))
        );
    }
    @Action(LoadTourUpdateHistorySuccessAction)
    LoadTourUpdateHistorySuccessAction(ctx: StateContext<ManagedTourStateModel>, action: LoadTourUpdateHistorySuccessAction) {
        ctx.patchState({
            isLoading: false,
            tourUpdateHistory: action.payload.tourUpdateHistory,
        });
    }

    @Action(LoadTourUpdateHistoryFailAction)
    LoadTourUpdateHistoryFailAction(ctx: StateContext<ManagedTourStateModel>, action: LoadTourUpdateHistoryFailAction) {
        ctx.patchState({
            isLoading: false,
            tourUpdateHistory: null
        });
    }

    @Action(GetTourByIdSuccessAction)
    GetTourByIdSuccessAction({ patchState }: StateContext<ManagedTourStateModel>, action: GetTourByIdSuccessAction) {
        patchState({ selectedTour: action.payload });
    }

    @Action(UpdateETAAction)
    UpdateETAAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: UpdateETAAction) {
        patchState({ isLoading: true });
        return this.tourService.updateETAByTourId(action.tourId, action.estimatedDateTime, action.updateType, action.note, action.latitude, action.longitude, action.vehicleDuration, action.vehicleDistance, action.address, action.restStartTime, action.restEndTime, action.historyId, action.transportOrderNumber).pipe(
            tap((updatedTour) => {
                dispatch(new UpdateETASuccessAction({ tour: updatedTour }));
            }),
            catchError(error => {
                dispatch(new UpdateETAFailAction());
                throw error;
            })
        );
    }

    @Action(UpdateETASuccessAction)
    updateETASuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: UpdateETASuccessAction) {
        const state = getState();
        // patchState({ tours: state.tours.map((tour) => (tour.id === action.payload.tour.id ? action.payload.tour : tour)) });
    }

    @Action(AssignUserAction)
    AssignUserAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: AssignUserAction) {
        patchState({ isLoading: true });

        return this.tourService.assignUserByTourId(action.id, action.userId).pipe(
            tap((tour) => {
                dispatch(new AssignUserSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new AssignUserFailAction());
                throw error;
            })
        );
    }

    @Action(AssignUserSuccessAction)
    assignUserSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: AssignUserSuccessAction) {
        const state = getState();
        // patchState({ tours: state.tours.map((tour) => (tour.id === action.payload.tour.id ? action.payload.tour : tour)) });
    }

    @Action(AssignVehicleAction)
    AssignVehicleAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: AssignVehicleAction) {
        patchState({ isLoading: true });

        return this.tourService.assignVehicleByTourId(action.id, action.vehicleId).pipe(
            tap((tour) => {
                dispatch(new AssignVehicleSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new AssignVehicleFailAction());
                throw error;
            })
        );
    }

    @Action(AssignVehicleSuccessAction)
    assignVehicleSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: AssignVehicleSuccessAction) {
        const state = getState();
        // patchState({ tours: state.tours.map((tour) => (tour.id === action.payload.tour.id ? action.payload.tour : tour)) });
    }

    //cancel tour
    @Action(CancelTourAction)
    cancelTourAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: CancelTourAction) {
        patchState({ isLoading: true });

        return this.tourService.cancelTourById(action.id).pipe(
            tap((tour) => {
                dispatch(new CancelTourSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new CancelTourFailAction());
                throw error;
            })
        );
    }

    @Action(CancelTourSuccessAction)
    cancelTourSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: CancelTourSuccessAction) {
        const state = getState();
        // patchState({ tours: state.tours.map((tour) => (tour.id === action.payload.tour.id ? action.payload.tour : tour)) });
    }
    //cancel tour
    @Action(UnCancelTourAction)
    unCancelTourAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: UnCancelTourAction) {
        patchState({ isLoading: true });

        return this.tourService.unCancelTourById(action.id).pipe(
            tap((tour) => {
                dispatch(new UnCancelTourSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new UnCancelTourFailAction());
                throw error;
            })
        );
    }

    @Action(UnCancelTourSuccessAction)
    UnCancelTourSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: UnCancelTourSuccessAction) {
        const state = getState();
        // patchState({ tours: state.tours.map((tour) => (tour.id === action.payload.tour.id ? action.payload.tour : tour)) });
    }
    //Mark Tour Update requested
    @Action(MakeTourHeldAtCustomsAction)
    MakeTourHeldAtCustomsAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: MakeTourHeldAtCustomsAction) {
        patchState({ isLoading: true });

        return this.tourService.makeTourHeldAtCustomsById(action.id, action.HeldAtCustoms).pipe(
            tap((tour) => {
                dispatch(new MakeTourHeldAtCustomsSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new MakeTourHeldAtCustomsFailAction());
                throw error;
            })
        );
    }

    @Action(MakeTourHeldAtCustomsSuccessAction)
    MakeTourHeldAtCustomsSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: MakeTourHeldAtCustomsSuccessAction) {
        const state = getState();
        // patchState({ tours: state.tours.map((tour) => (tour.id === action.payload.tour.id ? action.payload.tour : tour)) });
    }

    //Critical tour
    @Action(MakeTourCriticalAction)
    makeTourCriticalAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: MakeTourCriticalAction) {
        patchState({ isLoading: true });

        return this.tourService.makeTourCriticalById(action.id, action.isCritical).pipe(
            tap((tour) => {
                dispatch(new MakeTourCriticalSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new MakeTourCriticalFailAction());
                throw error;
            })
        );
    }

    //Update Tracking frequency
    @Action(UpdateTrackingFreqAction)
    updateTrackingFreqAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: UpdateTrackingFreqAction) {
        patchState({ isLoading: true });

        return this.tourService.updateTrackingFrequencyById(action.id, action.frequencyId).pipe(
            tap((tour) => {
                dispatch(new UpdateTrackingFreqSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new UpdateTrackingFreqFailAction());
                throw error;
            })
        );
    }

    //Save tour route
    @Action(SaveRouteAction)
    saveRouteAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: SaveRouteAction) {
        patchState({ isLoading: true });

        return this.tourService.saveRouteData(action.TourId, action.VehicleId, action.RouteData, action.EventTrigger, action.SuggestedETA, action.Distance).pipe(
            tap((route) => {
                dispatch(new SaveRouteSuccessAction({ route }));
            }),
            catchError(error => {
                dispatch(new SaveRouteFailAction());
                throw error;
            })
        );
    }


    //Save to cache
    @Action(TourLockHistoryByIdAction)
    tourLockHistoryByIdAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: TourLockHistoryByIdAction) {
        patchState({ isLoading: true });

        return this.tourService.getLockedTour(action.tourId).pipe(
            tap((response: TourLockedModel) => {
                response.locked
                dispatch(new TourLockHistoryByIdSuccessAction({ model: response }));
            }),
            catchError(error => {
                dispatch(new TourLockHistoryByIdFailAction());
                throw error;
            })
        );
    }

    @Action(TourLockHistoryByIdSuccessAction)
    tourLockHistoryByIdSuccessAction({ patchState }: StateContext<ManagedTourStateModel>, action: TourLockHistoryByIdSuccessAction) {
        patchState({
            isLoading: false,
            locked: action.payload.model.locked,
            name: action.payload.model.name,
        });
    }

    @Action(TourLockHistoryByIdFailAction)
    tourLockHistoryByIdFailAction({ patchState }: StateContext<ManagedTourStateModel>) {
        patchState({ isLoading: false });
    }


    // remove from cache
    @Action(RemoveTourLockByIdAction)
    removeTourLockByIdAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: RemoveTourLockByIdAction) {
        patchState({ isLoading: true });

        return this.tourService.removeFromCache(action.tourId).pipe(
            tap((response: any) => {
                dispatch(new RemoveTourLockByIdSuccessAction());
            }),
            catchError(error => {
                dispatch(new RemoveTourLockByIdFailAction());
                throw error;
            })
        );
    }

    @Action(RemoveTourLockByIdSuccessAction)
    removeTourLockByIdSuccessAction({ patchState }: StateContext<ManagedTourStateModel>, action: RemoveTourLockByIdSuccessAction) {
        patchState({ isLoading: false, });
    }

    @Action(RemoveTourLockByIdFailAction)
    removeTourLockByIdFailAction({ patchState }: StateContext<ManagedTourStateModel>) {
        patchState({ isLoading: false });
    }

    //Get Route by id
    @Action(GetRouteByTourIdAction)
    getRouteByTourIdAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: GetRouteByTourIdAction) {
        patchState({ isLoading: true });

        return this.tourService.getRouteByTourId(action.TourId).pipe(
            tap((route) => dispatch(new GetRouteByTourIdSuccessAction({ route }))),
            catchError((err) => dispatch(new GetRouteByTourIdFailAction()))
        );
    }

    @Action(GetRouteByTourIdSuccessAction)
    getRouteByTourIdActionSuccessAction(ctx: StateContext<ManagedTourStateModel>, action: GetRouteByTourIdSuccessAction) {
        ctx.patchState({
            isLoading: false,
            route: action.payload.route
        });
    }

    @Action(GetRouteByTourIdFailAction)
    getRouteByTourIdActionFailAction(ctx: StateContext<ManagedTourStateModel>, action: GetRouteByTourIdFailAction) {
        ctx.patchState({
            isLoading: false,
            route: undefined
        });
    }

    @Action(MakeTourCriticalSuccessAction)
    makeTourCriticalSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: MakeTourCriticalSuccessAction) {
        const state = getState();
        // patchState({ tours: state.tours.map((tour) => (tour.id === action.payload.tour.id ? action.payload.tour : tour)) });
    }

    //notes actions
    @Action(GetNotesAction)
    GetNotesAction({ patchState }: StateContext<ManagedTourStateModel>, action: GetNotesAction) {
        patchState({ isLoading: true });

        return this.noteService.getNotesByTourId(action.tourId).pipe(
            tap((notes) => patchState({ notes })),
        );
    }
    //Mark Tour Completed
    @Action(MarkTourCompletedAction)
    MarkTourCompletedAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: MarkTourCompletedAction) {
        patchState({ isLoading: true });

        return this.tourService.markTourCompleted(action.id).pipe(
            tap((tour) => {
                dispatch(new MarkTourCompletedSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new MarkTourCompletedFailAction());
                throw error;
            })
        );
    }

    @Action(MarkTourCompletedSuccessAction)
    MarkTourCompletedSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: MarkTourCompletedSuccessAction) {
        const state = getState();

    }

    @Action(AddNoteAction)
    AddNoteAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: AddNoteAction) {
        patchState({ isLoading: true });

        return this.noteService.addNoteByTourId(action.id, action.tourId, action.note).pipe(
            tap((addedNote) => {
                dispatch(new AddNoteSuccessAction(addedNote));
            }),
            catchError(error => {
                dispatch(new AddNoteFailAction());
                throw error;
            })
        );
    }

    @Action(AddNoteSuccessAction)
    AddNoteSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: AddNoteSuccessAction) {
        const state = getState();
        patchState({ notes: [...state.notes, action.payload] });
    }

    @Action(UpdateTrackingUrlAction)
    UpdateTrackingUrlAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: UpdateTrackingUrlAction) {
        patchState({ isLoading: true });

        return this.tourService.updateTrackingUrl(action.model).pipe(
            tap((addedNote) => {
                dispatch(new UpdateTrackingUrlSuccessAction());
            }),
            catchError(error => {
                dispatch(new UpdateTrackingUrlFailAction());
                throw error;
            })
        );
    }

    @Action(UpdateTrackingUrlSuccessAction)
    UpdateTrackingUrlSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: UpdateTrackingUrlSuccessAction) {
        const state = getState();
        patchState({ isLoading: false });
    }

    @Action(UpdateTrackingUrlFailAction)
    UpdateTrackingUrlFailAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: UpdateTrackingUrlFailAction) {
        const state = getState();
        patchState({ isLoading: false });
    }

    @Action(LoadTourHistoryListAction)
    loadTourHistoryListAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: LoadTourHistoryListAction) {
        patchState({ isLoading: true });

        return this.tourService.getTourHistory(action.payload.GetTourHistoryQuery).pipe(
            tap((tourHistoryList) => dispatch(new LoadTourHistoryListSuccessAction({ tourHistoryList }))),
            catchError((err) => dispatch(new LoadTourHistoryListFailAction()))
        );
    }

    @Action(LoadTourHistoryListSuccessAction)
    loadTourHistoryListSuccessAction(ctx: StateContext<ManagedTourStateModel>, action: LoadTourHistoryListSuccessAction) {
        ctx.patchState({
            isLoading: false,
            tourHistory: action.payload.tourHistoryList.results,
            tourHistoryList: action.payload.tourHistoryList
        });
    }

    @Action(LoadTourHistoryListFailAction)
    loadTourHistoryListFailAction(ctx: StateContext<ManagedTourStateModel>, action: LoadTourHistoryListFailAction) {
        ctx.patchState({
            isLoading: false,
            tourHistory: [],
            tourHistoryList: null
        });
    }

    @Action(CalculateDistanceAction)
    CalculateDistanceAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: CalculateDistanceAction) {
        patchState({ isLoading: true });

        return this.tourService.calculateTimeAndDistance(action.fromLat, action.fromLng, action.toLat, action.toLng, action.maxSpeed).pipe(
            tap((distanceModel) => dispatch(new CalculateDistanceSuccessAction(distanceModel))),
            catchError((err) => dispatch(new CalculateDistanceFailAction()))
        );
    }

    @Action(CalculateDistanceSuccessAction)
    CalculateDistanceSuccessAction(ctx: StateContext<ManagedTourStateModel>, action: CalculateDistanceSuccessAction) {
        ctx.patchState({
            isLoading: false,
        });
    }

    @Action(CalculateDistanceFailAction)
    CalculateDistanceFailAction(ctx: StateContext<ManagedTourStateModel>, action: CalculateDistanceFailAction) {
        ctx.patchState({
            isLoading: false,
        });
    }

    @Action(LoadTourListAction)
    loadTourListAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: LoadTourListAction) {
        patchState({ isLoading: true });

        return this.tourService.getTourList().pipe(
            tap((tours) => dispatch(new LoadTourListSuccessAction({ tours }))),
            catchError((err) => dispatch(new LoadTourListFailAction()))
        );
    }

    @Action(LoadTourListSuccessAction)
    loadTourListSuccessAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: LoadTourListSuccessAction) {
        patchState({
            isLoading: false,
            tourList: action.payload.tours
        });
        dispatch(new ApplyFiltersToToursAction());
    }

    @Action(LoadTourListFailAction)
    loadTourListFailAction(ctx: StateContext<ManagedTourStateModel>, action: LoadTourListFailAction) {
        ctx.patchState({
            isLoading: false,
            tourList: []
        });
    }
    @Action(LoadAdminTourListAction)
    loadAdminTourListAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: LoadAdminTourListAction) {
        patchState({ isLoading: true });

        return this.tourService.getAdminTourList(action.payload.GetAdminTourListQuery).pipe(
            tap((adminTourList) => dispatch(new LoadAdminTourListSuccessAction({ adminTourList }))),
            catchError((err) => dispatch(new LoadAdminTourListFailAction()))
        );
    }

    @Action(LoadAdminTourListSuccessAction)
    loadAdminTourListSuccessAction(ctx: StateContext<ManagedTourStateModel>, action: LoadAdminTourListSuccessAction) {
        ctx.patchState({
            isLoading: false,
            adminTours: action.payload.adminTourList.results,
            adminTourList: action.payload.adminTourList
        });
        //dispatch(new ApplyFiltersToAdminToursAction());
    }

    @Action(LoadAdminTourListFailAction)
    loadAdminTourListFailAction(ctx: StateContext<ManagedTourStateModel>, action: LoadAdminTourListFailAction) {
        ctx.patchState({
            isLoading: false,
            adminTourList: null
        });
    }

    @Action(SetCategoryFilterAction)
    setCategoryFilterAction({ patchState, dispatch }: StateContext<ManagedTourStateModel>, action: SetCategoryFilterAction) {
        patchState({
            selectedCategory: action.payload.selectedCategory
        });

        dispatch(new ApplyFiltersToToursAction());
    }

    @Action(SetDepartmentsFilterAction)
    SetDepartmentsFilterAction({ patchState, dispatch }: StateContext<ManagedTourStateModel>, action: SetDepartmentsFilterAction) {
        patchState({
            selectedDepartments: action.payload.selectedDepartments
        });

        dispatch(new ApplyFiltersToToursAction());
    }

    @Action(SetShipmentModeAction)
    SetShipmentModeAction({ patchState, dispatch }: StateContext<ManagedTourStateModel>, action: SetShipmentModeAction) {
        patchState({
            selectedModes: action.payload.selectedMode
        });

        dispatch(new ApplyFiltersToToursAction());
    }

    @Action(SetTypesFilterAction)
    SetTypesFilterAction({ patchState, dispatch }: StateContext<ManagedTourStateModel>, action: SetTypesFilterAction) {
        patchState({
            selectedTypes: action.payload.selectedTypes
        });

        dispatch(new ApplyFiltersToToursAction());
    }

    @Action(SetOwningUserFilterAction)
    SetOwningUserFilterAction({ patchState, dispatch }: StateContext<ManagedTourStateModel>, action: SetOwningUserFilterAction) {
        patchState({
            selectedOwningUsers: action.payload.selectedOwningUsers
        });

        dispatch(new ApplyFiltersToToursAction());
    }

    @Action(ApplyFiltersToAdminToursAction)
    /* applyFiltersToAdminToursAction(ctx: StateContext<ManagedTourStateModel>, action: ApplyFiltersToAdminToursAction) {
        const state = ctx.getState();
        const filteredTours = this.filterTours(state.adminTourList, state.selectedCategory, state.selectedDepartments, state.selectedTypes);

        ctx.patchState({
            filteredAdminTourList: filteredTours
        });
    } */
    @Action(ApplyFiltersToToursAction)
    applyFiltersToToursAction(ctx: StateContext<ManagedTourStateModel>, action: ApplyFiltersToToursAction) {
        const state = ctx.getState();

        // Get the dataSourceConfig from the store
        const dataSourceConfigs = this.store.selectSnapshot((state: any) => state.dataSourceConfigs?.dataSourceConfigs || []);
        const tourListConfig = dataSourceConfigs.find((config: any) => config.name === 'tour-list-table');

        const filteredTours = this.filterTours(state.tourList, state.selectedCategory, state.selectedDepartments, state.selectedTypes, state.selectedModes, state.selectedOwningUsers, tourListConfig);

        ctx.patchState({
            filteredTourList: filteredTours
        });
    }

    private filterTours(tours: TourModel[], selectedCategory: string, selectedDepartments: number[], selectedTypes: number[], selectedModes: string[], selectedOwningUsers: string[], dataSourceConfig?: any): TourModel[] {
        // Fetch available types based on selected departments
        // const availableTypes = this.getAvailableTypes(selectedDepartments);
        const auth = localStorage.getItem('auth');
        var s: any = JSON.parse(auth);
        const sanitizedUserName = s.decodedToken.username.replace(/"/g, '');
        const isManager = s.decodedToken.roles.includes('Manager');
        // Check if at least one tour is assigned to the logged-in user
        const isUserAssignedToAnyTour = tours.some(tour => tour.assignedUser === sanitizedUserName);
        // Filter tours
        const filteredTours = tours.filter(tour => {
            // Check if the logged-in user is assigned to at least one tour

            const categoryMatch = selectedCategory === '' || selectedCategory === 'All jobs' || tour.categoryName === selectedCategory;
            const isLinkedToUser = isUserAssignedToAnyTour && tour.assignedUser === sanitizedUserName;
            const currentDate = new Date();
            const sixHoursAhead = new Date();
            sixHoursAhead.setHours(sixHoursAhead.getHours() + 6);

            // Add owning user filter
            const owningUserMatch = selectedOwningUsers.length === 0 || selectedOwningUsers.includes(tour.owningUser);

            if (typeof tour.estimatedDateTime === 'string') {
                tour.estimatedDateTime = new Date(new Date(tour.estimatedDateTime).getTime());
            }

            if (typeof tour.lastActionDate === 'string') {
                tour.lastActionDate = new Date(new Date(tour.lastActionDate).getTime());
            }

            // if (typeof tour.plannedDeliveryEnd === 'string') {
            //     tour.plannedDeliveryEnd = new Date(tour.plannedDeliveryEnd);
            // }

            // if (typeof tour.plannedLoadingEnd === 'string') {
            //     tour.plannedLoadingEnd = new Date (new Date(tour.plannedLoadingEnd).getTime());
            // }

            if (typeof tour.estimatedDateTime === 'string') {
                tour.estimatedDateTime = new Date(new Date(tour.estimatedDateTime).getTime());
            }

            // Check specific fields for 'Critical' category
            if (selectedCategory === 'Hypercare') {
                return isUserAssignedToAnyTour ?
                    isLinkedToUser && tour.isCritical === true && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0) :
                    tour.isCritical === true && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId));
            }
            else if (selectedCategory === 'Update due soon') {
                return isUserAssignedToAnyTour ?
                    tour.updateDueDate < sixHoursAhead && isLinkedToUser && tour.updateDueSoon === true && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0) :
                    tour.updateDueDate < sixHoursAhead && tour.updateDueSoon === true && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId));
            }
            else if (selectedCategory === 'Update due') {
                return isUserAssignedToAnyTour ?
                    tour.updateDueDate < sixHoursAhead && isLinkedToUser && tour.updateOverDue === true && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0) :
                    tour.updateDueDate < sixHoursAhead && tour.updateOverDue === true && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId));
            }
            else if (selectedCategory === 'Intransit update due soon') {
                return isUserAssignedToAnyTour ?
                    tour.updateDueDate < sixHoursAhead && isLinkedToUser && tour.updateDueSoon === true && tour.categoryName === 'Intransit (all)' && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0) :
                    tour.updateDueDate < sixHoursAhead && tour.updateDueSoon === true && tour.categoryName === 'Intransit (all)' && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId));
            }
            else if (selectedCategory === 'Delivery late') {
                return isUserAssignedToAnyTour ?
                    tour.updateDueDate < sixHoursAhead && isLinkedToUser &&
                    (currentDate > new Date(tour.plannedDeliveryEnd) || tour.estimatedDateTime > new Date(tour.plannedDeliveryEnd))
                    && (tour.categoryName === 'Intransit (all)' || tour.categoryName === 'Intransit overdue') && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0) :
                    tour.updateDueDate < sixHoursAhead && (currentDate > new Date(tour.plannedDeliveryEnd) || tour.estimatedDateTime > new Date(tour.plannedDeliveryEnd))
                    && (tour.categoryName === 'Intransit (all)' || tour.categoryName === 'Intransit overdue') && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId));
            }
            // Check specific fields for 'HeldAtCustoms' category
            else if (selectedCategory === 'Update requested') {
                return isUserAssignedToAnyTour ?
                    tour.updateDueDate < sixHoursAhead && isLinkedToUser && tour.heldAtCustoms === true && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId)) :
                    tour.updateDueDate < sixHoursAhead && tour.heldAtCustoms === true && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId));
            }
            else if (selectedCategory === 'All jobs') {
                const departmentMatch = selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId);
                const typeMatch = selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId);
                const shipment = selectedModes.length === 0 || selectedModes.includes(tour.shipmentMode);

                // Apply additional condition for records linked to the logged-in user if at least one tour is assigned
                return isUserAssignedToAnyTour ? (isLinkedToUser && categoryMatch && departmentMatch && typeMatch && shipment && owningUserMatch) : (categoryMatch && departmentMatch && typeMatch && shipment && owningUserMatch);
            }
            else if (selectedCategory === 'Intransit (all)' || selectedCategory === 'Awaiting POD') {
                const departmentMatch = selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId);
                const typeMatch = selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId);
                const shipment = selectedModes.length === 0 || selectedModes.includes(tour.shipmentMode);

                // Apply additional condition for records linked to the logged-in user if at least one tour is assigned
                return isUserAssignedToAnyTour ? (isLinkedToUser && categoryMatch && departmentMatch && typeMatch && shipment && owningUserMatch) : (categoryMatch && departmentMatch && typeMatch && shipment && owningUserMatch);
            } else if (selectedCategory === 'Awaiting Validation') {
                return isManager && tour.requiresValidation === true && (tour.approved === null) && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId)) && owningUserMatch;
            }             else if (selectedCategory === 'Rejected') {
                return !isManager && tour.approved === false && tour.assignedUser === sanitizedUserName && (selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId)) && (selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId)) && owningUserMatch;
            }
            else if (selectedCategory === 'Drivers on Rest') {
                const departmentMatch = selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId);
                const typeMatch = selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId);
                const shipment = selectedModes.length === 0 || selectedModes.includes(tour.shipmentMode);

                // Filter tours where updateTypeLookupId is 12 (Drivers on Rest)
                const isDriverOnRest = tour.updateTypeLookupId === 12;

                return isUserAssignedToAnyTour ?
                    (isLinkedToUser && isDriverOnRest && departmentMatch && typeMatch && shipment && owningUserMatch) :
                    (isDriverOnRest && departmentMatch && typeMatch && shipment && owningUserMatch);
            }
            // Default behavior for other categories
            else {

                const departmentMatch = selectedDepartments.length === 0 || selectedDepartments.includes(tour.departmentLookupId);
                const typeMatch = selectedTypes.length === 0 || selectedTypes.includes(tour.typeLookupId);
                const shipment = selectedModes.length === 0 || selectedModes.includes(tour.shipmentMode);
                const within6Hours = tour.updateDueDate < sixHoursAhead;
                // Apply additional condition for records linked to the logged-in user if at least one tour is assigned
                return isUserAssignedToAnyTour ? (isLinkedToUser && categoryMatch && departmentMatch && typeMatch && shipment && within6Hours && owningUserMatch) : (categoryMatch && departmentMatch && typeMatch && shipment && within6Hours && owningUserMatch);
            }
        });

        // Apply sorting based on dataSourceConfig if available, otherwise use default sorting
        let sortedTours = filteredTours;

        if (dataSourceConfig && dataSourceConfig.sortBy && dataSourceConfig.sortByOrder) {
            sortedTours = filteredTours.sort((a, b) => {
                // Ensure "Awaiting pod" status appears at the bottom
                if (a.categoryName === "Awaiting POD" && b.categoryName !== "Awaiting POD") return 1;
                if (b.categoryName === "Awaiting POD" && a.categoryName !== "Awaiting POD") return -1;

                let aValue: any;
                let bValue: any;

                // Map the sortBy field to the actual property
                switch (dataSourceConfig.sortBy) {
                    case 'AmcoId':
                        aValue = a.amcoId;
                        bValue = b.amcoId;
                        break;
                    case 'CustomerName':
                        aValue = a.customerName;
                        bValue = b.customerName;
                        break;
                    case 'TargetDateTime':
                        aValue = a.targetDateTime;
                        bValue = b.targetDateTime;
                        break;
                    case 'CategoryName':
                        aValue = a.categoryName;
                        bValue = b.categoryName;
                        break;
                    default:
                        // Default to updateDueDate if no valid sort field
                        aValue = new Date(a.updateDueDate).getTime();
                        bValue = new Date(b.updateDueDate).getTime();
                }

                // Handle string comparison
                if (typeof aValue === 'string' && typeof bValue === 'string') {
                    const comparison = aValue.localeCompare(bValue);
                    return dataSourceConfig.sortByOrder === 'desc' ? -comparison : comparison;
                }

                // Handle date comparison
                if (aValue instanceof Date && bValue instanceof Date) {
                    const comparison = aValue.getTime() - bValue.getTime();
                    return dataSourceConfig.sortByOrder === 'desc' ? -comparison : comparison;
                }

                // Handle number comparison
                if (typeof aValue === 'number' && typeof bValue === 'number') {
                    const comparison = aValue - bValue;
                    return dataSourceConfig.sortByOrder === 'desc' ? -comparison : comparison;
                }

                // Fallback to default sorting
                const dateA = new Date(a.updateDueDate).getTime();
                const dateB = new Date(b.updateDueDate).getTime();

                if (isNaN(dateA) && isNaN(dateB)) return 0;
                if (isNaN(dateA)) return 1;
                if (isNaN(dateB)) return -1;

                if (dateA !== dateB) return dateA - dateB;

                const lastActionDateA = new Date(a.lastActionDate).getTime();
                const lastActionDateB = new Date(b.lastActionDate).getTime();

                if (isNaN(lastActionDateA) && isNaN(lastActionDateB)) return 0;
                if (isNaN(lastActionDateA)) return 1;
                if (isNaN(lastActionDateB)) return -1;

                return lastActionDateA - lastActionDateB;
            });
        } else {
            // Default sorting logic
            sortedTours = filteredTours.sort((a, b) => {
                // Ensure "Awaiting pod" status appears at the bottom
                if (a.categoryName === "Awaiting POD" && b.categoryName !== "Awaiting POD") return 1;
                if (b.categoryName === "Awaiting POD" && a.categoryName !== "Awaiting POD") return -1;

                const dateA = new Date(a.updateDueDate).getTime();
                const dateB = new Date(b.updateDueDate).getTime();

                // Handle invalid dates
                if (isNaN(dateA) && isNaN(dateB)) return 0; // both invalid, consider them equal
                if (isNaN(dateA)) return 1; // only a is invalid, push it to the end
                if (isNaN(dateB)) return -1; // only b is invalid, push it to the end

                // Sort by updateDueDate first
                if (dateA !== dateB) return dateA - dateB;

                // If updateDueDate is the same, sort by lastActionDate
                const lastActionDateA = new Date(a.lastActionDate).getTime();
                const lastActionDateB = new Date(b.lastActionDate).getTime();

                if (isNaN(lastActionDateA) && isNaN(lastActionDateB)) return 0; // both invalid, consider them equal
                if (isNaN(lastActionDateA)) return 1; // only a is invalid, push it to the end
                if (isNaN(lastActionDateB)) return -1; // only b is invalid, push it to the end

                return lastActionDateA - lastActionDateB;
            });
        }

        return sortedTours;
    }

    private getAvailableTypes(selectedDepartments: number[]): number[] {
        // Implement logic to fetch available types based on selected departments
        // This could be an API call or some other mechanism to get the types for the selected departments.
        // For demonstration purposes, let's assume a simple mapping in this example.
        const departmentTypeMapping: { [key: number]: number[] } = {
            1: [1, 2], // Department 1 has types 1 and 2
            2: [3, 4], // Department 2 has types 3 and 4
        };

        return selectedDepartments.reduce((types, department) => types.concat(departmentTypeMapping[department] || []), []);
    }

    @Action(RegisterSignalRHandlersForTourAction)
    RegisterSignalRHandlersForTourAction({ getState, dispatch, patchState }: StateContext<ManagedTourStateModel>, action: RegisterSignalRHandlersForTourAction) {
        const updateTourList = (updatedTours: TourModel[]) => {
            patchState({
                tourList: updatedTours
            });
            //Update customer screens as well in case something changed

            const MyTourHistoryQueryJson = localStorage.getItem('MyTourHistoryQuery');
            if (MyTourHistoryQueryJson) {
                const query: GetMyTourHistoryQuery = JSON.parse(MyTourHistoryQueryJson);
                dispatch(new LoadMyTourHistoryListAction({ GetMyTourHistoryQuery: query }));
            }

            dispatch(new LoadMyTourListAction());
            dispatch(new LoadActiveTourListAction());
            dispatch(new LoadDashboardsAction());
            dispatch(new LoadCustomsDashboardsV1Action);
            dispatch(new LoadCustomsListAction);
            dispatch(new ApplyFiltersToToursAction());
        };

        this.signalRService.getHubConnection().on('SendTour', (updatedTour: TourModel) => {
            const state = getState();
            let updatedTours: TourModel[] = [];
            // updatedTours = state.tourList ? state.tourList.map(tour => (tour.id === updatedTour.id ? updatedTour : tour)) : [updatedTour];
            // Check if the updated tour is completed

            if (typeof updatedTour.updateDueDate === 'string') {
                updatedTour.updateDueDate = new Date(new Date(updatedTour.updateDueDate).getTime());
            }

            if (typeof updatedTour.lastActionDate === 'string') {
                updatedTour.lastActionDate = new Date(new Date(updatedTour.lastActionDate).getTime());
            }

            // if (typeof updatedTour.plannedDeliveryEnd === 'string') {
            //     updatedTour.plannedDeliveryEnd = new Date(new Date(updatedTour.plannedDeliveryEnd).getTime());
            // }

            // if (typeof updatedTour.plannedLoadingEnd === 'string') {
            //     updatedTour.plannedLoadingEnd = new Date(new Date(updatedTour.plannedLoadingEnd).getTime());
            // }


            if (typeof updatedTour.suggestedETA === 'string') {
                updatedTour.suggestedETA = new Date(new Date(updatedTour.suggestedETA).getTime());
            }


            if (typeof updatedTour.estimatedDateTime === 'string') {
                updatedTour.estimatedDateTime = new Date(new Date(updatedTour.estimatedDateTime).getTime());
            }

            if (updatedTour.completed || updatedTour.isCancelled) {
                // Remove the completed tour from the list
                updatedTours = state.tourList.filter(tour => tour.id !== updatedTour.id);
            } else {
                // Update the tour in the list
                updatedTours = state.tourList.map(tour => (tour.id === updatedTour.id ? updatedTour : tour));
            }
            updateTourList(updatedTours);
        });



        this.signalRService.getHubConnection().on('SendTourList', (tourList: TourModel[]) => {
            const state = getState();

            if (tourList.length > 0) {

                const updatedTours = state.tourList ? state.tourList.map(existingTour => {
                    if (typeof existingTour.updateDueDate === 'string') {
                        existingTour.updateDueDate = new Date(new Date(existingTour.updateDueDate).getTime());
                    }

                    if (typeof existingTour.lastActionDate === 'string') {
                        existingTour.lastActionDate = new Date(new Date(existingTour.lastActionDate).getTime());
                    }

                    // if (typeof existingTour.plannedDeliveryEnd === 'string') {
                    //     existingTour.plannedDeliveryEnd = new Date (new Date(existingTour.plannedDeliveryEnd).getTime());
                    // }


                    // if (typeof existingTour.plannedLoadingEnd === 'string') {
                    //     existingTour.plannedLoadingEnd = new Date (new Date(existingTour.plannedLoadingEnd).getTime());
                    // }

                    if (typeof existingTour.estimatedDateTime === 'string') {
                        existingTour.estimatedDateTime = new Date(new Date(existingTour.estimatedDateTime).getTime());
                    }

                    const matchingTour = tourList.find(newTour => newTour.id === existingTour.id);

                    if (matchingTour) {
                        // Only update updateDueDate and isDeleted properties
                        existingTour.updateOverDue = matchingTour.updateOverDue;
                        existingTour.updateDueSoon = matchingTour.updateDueSoon;
                    }

                    return existingTour;
                }) : tourList;
                updateTourList(updatedTours);
            }
        });

        patchState({
            signalRHandlersRegistered: true
        });
    }

    // Tour History
    @Action(CreateTourHistoryByTourIdAction)
    createTourHistoryByTourIdAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: CreateTourHistoryByTourIdAction) {
        patchState({ isLoading: true });

        return this.tourService.createHistoryByTourId(action.payload.tourId,
            action.payload.eta,
            action.payload.isApproved,
            action.payload.note,
            action.payload.rejectionComments,
            action.payload.updateTypeLookupId,
            action.payload.requiresValidation,
            action.payload.vehicleLat,
            action.payload.vehicleLng,
            action.payload.vehicleDur,
            action.payload.vehicleDistance,
            action.payload.place).pipe(
            tap((tourHistory) => {
                dispatch(new CreateTourHistoryByTourIdSuccessAction({ tourHistory }));
            }),
            catchError(error => {
                dispatch(new CreateTourHistoryByTourIddFailAction());
                throw error;
            })
        );
    }

    //Update history item
    @Action(UpdateHistoryItemByIdAction)
    updateHistoryItemByIdAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: UpdateHistoryItemByIdAction) {
        patchState({ isLoading: true });

        return this.tourService.updateHistoryItemById(action.payload.tourId, action.payload.eta, action.payload.isApproved, action.payload.note, action.payload.rejectionComments, action.payload.requiresValidation, action.payload.isEdit).pipe(
            tap((tourHistory) => {
                dispatch(new UpdateHistoryItemByIdSuccessAction({ tourHistory }));
            }),
            catchError(error => {
                dispatch(new UpdateHistoryItemByIdFailAction());
                throw error;
            })
        );
    }

    //Disable history item
    @Action(DisableHistoryItemIdAction)
    disableHistoryItemIdAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: DisableHistoryItemIdAction) {
        patchState({ isLoading: true });

        return this.tourService.disableHistoryItemById(action.id, action.tourId).pipe(
            tap(() => {
                dispatch(new DisableHistoryItemIdSuccessAction());
            }),
            catchError(error => {
                dispatch(new DisableHistoryItemIdFailAction());
                throw error;
            })
        );
    }

    //Mark Tour Update requested
    @Action(LogAnIssueAction)
    LogAnIssueAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: LogAnIssueAction) {
        patchState({ isLoading: true });

        return this.tourService.logAnIssueByTourId(action.tourId,
            action.causeOfIssue,
            action.impact,
            action.reasonForIssue,
            action.isLoggedByCustomer,
            action.hasCustomerBeenCalled,
            action.hasCarrierBeenCalled,
            action.notes,
            action.eta,
            action.historyId,
            action.tourHistoryId,
            action.status,
            action.escalateIssue,
            action.isControlRoom,
            action.managerActions,
            action.issueActions,
            action.priority).pipe(
            tap((tour) => {
                dispatch(new LogAnIssueSuccessAction());
            }),
            catchError(error => {
                dispatch(new LogAnIssueFailAction());
                throw error;
            })
        );
    }

    @Action(LogAnIssueSuccessAction)
    LogAnIssueSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: LogAnIssueSuccessAction) {
        const state = getState();
    }

    @Action(LoadLoggedIssuesAction)
    loadLoggedIssues({ dispatch, patchState }: StateContext<ManagedTourStateModel>,  action: LoadLoggedIssuesAction) {
        patchState({ isLoading: true }); // Set loading state and clear error
        return this.tourService.getLoggedIssueByTourId(action.tourId).pipe(
            tap((issues) => dispatch(new LoadLoggedIssuesSuccessAction({ tours: issues }))),
            catchError((err) => {
                dispatch(new LoadLoggedIssuesFailAction());
                return [];
            })
        );
    }

    @Action(LoadLoggedIssuesSuccessAction)
    loadLoggedIssuesSuccess(ctx: StateContext<ManagedTourStateModel>, action: LoadLoggedIssuesSuccessAction) {
        ctx.patchState({
            isLoading: false,
            loggedIssues: action.payload.tours,
        });
    }

    @Action(LoadLoggedIssuesFailAction)
    loadLoggedIssuesFail(ctx: StateContext<ManagedTourStateModel>) {
        ctx.patchState({
            isLoading: false,
        });
    }

    @Action(CloseIssueAction)
    closeIssueAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: CloseIssueAction) {
        patchState({ isLoading: true });

        return this.tourService.closeIssueById(action.id, action.tourId).pipe(
            tap(() => dispatch(new CloseIssueSuccessAction())),
            catchError(error => {
                dispatch(new CloseIssueFailAction());
                throw error;
            })
        );
    }

    @Action(CloseIssueSuccessAction)
    closeIssueSuccessAction(ctx: StateContext<ManagedTourStateModel>, action: CloseIssueSuccessAction) {
        ctx.patchState({
            isLoading: false,
        });
    }

    @Action(CloseIssueFailAction)
    closeIssueFailAction(ctx: StateContext<ManagedTourStateModel>, action: CloseIssueFailAction) {
        ctx.patchState({
            isLoading: false,
        });
    }

    @Action(AddTrailerRegByTourIdAction)
    AddTrailerRegByTourIdAction({ dispatch, patchState }: StateContext<ManagedTourStateModel>, action: AddTrailerRegByTourIdAction) {
        patchState({ isLoading: true });
        return this.tourService.addTrailerRegByTourId(action.id, action.regNumber).pipe(
            tap((tour) => {
                dispatch(new AddTrailerRegByTourIdSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new AddTrailerRegByTourIdFailAction());
                throw error;
            })
        );
    }

    @Action(AddTrailerRegByTourIdSuccessAction)
    AddTrailerRegByTourIdSuccessAction({ patchState, getState }: StateContext<ManagedTourStateModel>, action: AddTrailerRegByTourIdSuccessAction) {
        const state = getState();
        // Optionally update tourList or selectedTour here if needed
        patchState({ isLoading: false });
    }

    @Action(AddTrailerRegByTourIdFailAction)
    AddTrailerRegByTourIdFailAction({ patchState }: StateContext<ManagedTourStateModel>, action: AddTrailerRegByTourIdFailAction) {
        patchState({ isLoading: false });
    }


    @Action(RegisterSignalRHandlersForChatShAction)
    registerSignalRHandlersForChatShAction({ getState, dispatch, patchState }: StateContext<ManagedTourStateModel>, action: RegisterSignalRHandlersForChatShAction) {
        console.log('Message sent back for non control tower');

      this.signalRService.getHubConnection().on('SendChatMessage', (updatedChat: EscalationHistoryModel) => {
          const tourId = updatedChat.tourId;
          const amcoId = updatedChat.amcoId;
          const sender = updatedChat.createdBy;
          const messageType = updatedChat.type;

          const token = this.store.selectSnapshot(AuthState.getDecodedToken);
          const hasControlTowerUserRole = token.roles.includes("ControlTowerUser");

          let notificationMessage = '';
          if (messageType === 'ControlTower') {
            notificationMessage = `New Message for Shipment ID ${amcoId} from Control Room`;
          } else if (messageType !== 'ControlTower') {
            notificationMessage = `New Message for Shipment ID ${amcoId} from User ${sender}`;
          }
          console.log('Has control tower user role' + hasControlTowerUserRole + 'message is from' + messageType);

          if(!hasControlTowerUserRole && messageType === 'ControlTower'){
            if (notificationMessage) {
                console.log('Message sent');
                this.store.dispatch(new AddNotificationSh({ message: notificationMessage, tourId }));
                this.playNotificationSound();
                this.showNotificationPopup(notificationMessage, tourId, amcoId);
            }
        }

        dispatch(new LoadControlTowerDashboardsAction());
        dispatch(new LoadEscalatedToursAction());
        });

        // Listen for new customs chat messages - show notification if message is from Customs side
        this.signalRService.getHubConnection().on('SendCustomsHistory', (message: CustomsHistoryModel) => {
            const customsState = this.store.selectSnapshot(CustomsState);

            // Do not show notification or red dot to the sender - skip if we recently sent to this tour
            const recentlySentByMe = customsState?.lastSentCustomsMessageTourId != null &&
                message.tourId === customsState.lastSentCustomsMessageTourId &&
                customsState?.lastSentCustomsMessageAt != null &&
                (Date.now() - customsState.lastSentCustomsMessageAt) < 5000;
            if (recentlySentByMe) {
                return;
            }

            // If message is from Customs side (sent from customs listing), show notification on managed-tours side
        if (message.type === "Customs") {
            // Show snackbar notification
            this.store.dispatch(new OpenSnackbarAction({
                message: `New customs message received for tour ${message.amcoId || message.tourId}`,
                type: SnackbarType.Simple
            }));

            // Set has new messages flag for managed tours side (red dot on List Tour)
            dispatch(new SetHasNewMessagesForManagedToursAction({ hasNewMessages: true }));

            // Reload open chats list to update counts
            dispatch(new LoadListOfOpenChatsAction());
        }
        // If message is from Tracking side (sent from list tour), show notification on customs listing side
        else if (message.type === "Tracking") {
            // Show snackbar notification
            this.store.dispatch(new OpenSnackbarAction({
                message: `New customs message received for tour ${message.amcoId || message.tourId}`,
                type: SnackbarType.Simple
            }));

            // Set has new messages flag for customs listing side (red dot on Customs)
            dispatch(new SetHasNewMessagesForCustomsListAction({ hasNewMessages: true }));

            // Reload open chats list to update counts
            dispatch(new LoadListOfOpenChatsAction());
        }
        });

        patchState({
          signalRHandlersRegistered: true
        });

    }


    private showNotificationPopup(message: string, shipmentId: number, amcoId: number) {
        this.snackBar.openFromComponent(NotificationSnackbarComponent, {
          data: {
            message: message,
            onView: () => this.viewNotification(shipmentId, amcoId)
          },
          duration: 0,
          verticalPosition: 'bottom',
          horizontalPosition: 'right',
          panelClass: ['notification-popup']
        });
    }


    viewNotification(shipmentId: number, amcoId: number) {
        this.openEscalationChat(shipmentId, " ", true, amcoId, "Low")
        this.store.dispatch(new RemoveNotificationSh(shipmentId));
    }

    openEscalationChat(tourId: number, topic: string, status: boolean, amcoId: number, priority: string){
        const dialogRef = this.dialog.open(EscalationChatDialogComponent, {
            data: {
                id: tourId,
                topic: topic,
                status: status,
                amcoId: amcoId,
                prio: priority,
                isCustomsChat: false,
                hasOpenChat: false
            }, width: '650px'
        });

        dialogRef.afterClosed().subscribe(result => {});
    }

    private playNotificationSound() {
      const audio = new Audio('/assets/sounds/mixkit-bell-notification-933.wav');
      audio.play();
    }

    @Action(ClearSelectedTourAction)
    ClearSelectedTourAction(ctx: StateContext<ManagedTourStateModel>) {
        ctx.patchState({ selectedTour: null });
    }

}
